import styled from 'styled-components';
import { captionLink } from 'ui/theme';

const CaptionLink = styled.a`
  ${captionLink}
`;

type Props = {
  href: string;
  label: string;
};

export const FooterLink = ({ href, label }: Props) => {
  return (
    <CaptionLink href={href} data-test="footer-link">
      {label}
    </CaptionLink>
  );
};
